import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Container from '../atoms/Container';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import _uniqueId from 'lodash/uniqueId';

gsap.registerPlugin( ScrollTrigger );

const Holder = styled.div`
  background-color: ${props => props.theme.colours.grey};
  padding: 4rem 0;
`;

const Inner = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
  @media( ${props => props.theme.breakpoints.md} ) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media( ${props => props.theme.breakpoints.lg} ) {
    grid-gap: 3rem;
  }
`;

function ThreeColumn( { children } ) {
  const [ id, setId ] = useState( null );
  const holder = useRef( null );
  const tl = useRef( null );

  useEffect(() => {
    setId( _uniqueId( 'three-col-' ) );
  }, []);

  useEffect( () => {
    if ( !tl.current && id ) {
      tl.current = ScrollTrigger.matchMedia( {
        // desktop
        '(min-width: 576px)': function () {
          gsap.timeline( {
            scrollTrigger: {
              trigger: holder.current,
              start: 'top 75%',
              end: 'top 25%',
              scrub: true,
            }
          } )
          .from( `#${id} .card`, {
            yPercent: 50,
            autoAlpha: 0,
            duration: 1,
            stagger: 0.5,
          } );
        }
      } );
    }
  }, [ id ] );

  return (
    <Holder ref={holder}>
      <Container>
        <Inner id={id}>{children}</Inner>
      </Container>
    </Holder>
  )
}

export default ThreeColumn;
